import { isAppPortocar } from '@/index';
import { useWorkorderDetailContext } from '../../WorkorderDetailProvider';
import { useWorkOrderEmployeerDiscount } from '@/core/domain/workorder/WorkOrders/WorkOrders.hooks';
import { Checkbox, message } from 'antd';
import { useMemo } from 'react';
import { WorkOrderComplementStatus } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';

export default function WorkOrderServiceDiscountConfig() {
  const {
    workorder: { data: workOrder },
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const isClosed = useMemo(
    () => complement?.status === WorkOrderComplementStatus.Closed,
    [complement?.status],
  );

  const isCancelled = useMemo(
    () => complement?.status === WorkOrderComplementStatus.Cancelled,
    [complement?.status],
  );

  const workOrderEmplyeerDiscount = useWorkOrderEmployeerDiscount();

  if (!isAppPortocar) return null;

  return (
    <>
      <strong style={{ fontSize: '1.1rem' }}>
        Configuração de desconto de serviço
      </strong>

      <div style={{ marginBottom: 24 }}>
        <Checkbox
          checked={!!workOrder?.employeeDiscount}
          disabled={
            workOrderEmplyeerDiscount.isLoading ||
            isClosed ||
            isCancelled ||
            !!workOrder?.employeeDiscount ||
            !!workOrder?.partnerDiscount
          }
          onChange={({ target }) => {
            if (!workOrder?.id)
              return message.error('Não há dados do orçamento');

            workOrderEmplyeerDiscount.mutateAsync({
              applyEmployeeDiscount: target.checked,
              workOrderId: workOrder?.id,
            });
          }}
        >
          {workOrderEmplyeerDiscount.isLoading
            ? 'Habilitando desconto obrigatório...'
            : 'Habilitar desconto obrigatório de serviços para funcionário Porto'}
        </Checkbox>
      </div>
    </>
  );
}
